import { getTransactionId } from '../../common/data';
import { callFesWithLoading } from '../index';

/**
 * - Will send tan to mobile phone number located in data storage entry dataStorageId points to.
 */
export const sendTanToNumber = (dataStorageId: string): Promise<any> => {
  return callFesWithLoading.post(`auth/${dataStorageId}/tan/send`, {});
};

export const validateTan = (data: any): Promise<any> => {
  const dataStorageId = getTransactionId();
  return callFesWithLoading.post(`auth/${dataStorageId}/tan/validate`, data);
};
